import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React from "react";

export default function TableSelectionAutocompleteInput({
  tablesWithStatus = [],
  selectedTable,
  value,
  onChange,
}) {
  const flattenedTables = tablesWithStatus.flatMap((area) =>
    area.tables.map((t) => ({
      ...t,
      dine_area_name: area.name,
      dine_area_id: area.id,
    }))
  );

  const getTableLabel = (t) => `${t.name} (${t.dine_area_name})`;

  return (
    <Autocomplete
      options={flattenedTables}
      groupBy={(option) => option.dine_area_name}
      getOptionLabel={(option) => getTableLabel(option)}
      value={
        flattenedTables.find(
          (t) => t.dine_area_table_id === value?.dine_area_table_id
        ) || null
      }
      onChange={onChange}
      slotProps={{
        listbox: {
          sx: {
            maxHeight: 280,
            overflowY: "auto",
          },
        },
      }}
      renderInput={(params) => (
        <TextField {...params} label="Select New Table" fullWidth />
      )}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        const isCurrent =
          option.dine_area_table_uid ===
          selectedTable?.table?.dine_area_table_uid;
        const isFree = option.order_dine_table_status_id === "0";
        const disabled = !isFree || isCurrent;

        return (
          <li
            key={key}
            {...rest}
            style={{
              opacity: disabled ? 0.45 : 1,
              pointerEvents: disabled ? "none" : "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography>{option.name}</Typography>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  color: isCurrent
                    ? "warning.main"
                    : isFree
                    ? "success.main"
                    : "error.main",
                }}
              >
                {isCurrent ? "Current" : isFree ? "Free" : "Occupied"}
              </Typography>
            </Box>
          </li>
        );
      }}
    />
  );
}
